import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DATETIME_FORMAT_DATE } from '../../../../../utils/helpers/CommonHelper.jsx';
import { RawHtml } from '../../../../common/index.jsx';
import {
  StyledModal,
  StyledModalHeader,
} from '../../../../common/form/FormElements.jsx';

const renderFilePreview = (t, value, label) => {
  if (!value) {
    return null;
  }

  if (value instanceof File) {
    return (
      <div>
        <b>{label} &nbsp;</b>
        {value.name}
      </div>
    );
  }

  return (
    <a href={value} target="_blank" rel="noreferrer">
      {label}
    </a>
  );
};

const PhdThesesDefendModal = ({ visible, onCancel, values }) => {
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  return (
    <div className="hp-news-modal-container add-icons-to-file-anchors">
      <StyledModal open={visible} size="lg" onCancel={onCancel} footer={null}>
        <StyledModalHeader>
          <a className="second-title title" href="#">
            {values?.title_sk || '--neuvedene--'}
          </a>
        </StyledModalHeader>
        <div style={{ padding: '10px' }}>
          <div>
            <b>{t('Autor')} &nbsp;</b>
            {values?.student_display_name}
          </div>

          <div>
            <b>{t('Školiteľ')} &nbsp;</b>
            {values?.supervisor_display_name}
          </div>

          <div>
            <b>{t('Dátum obhajoby')} &nbsp;</b>
            {values?.defended_at?.format?.(DATETIME_FORMAT_DATE) || ''}
          </div>

          <div>
            <b>{t('Študijný program')} &nbsp;</b>
            {values?.legacy_study_program_name}
          </div>

          <div>
            <b>{t('Oponent 1')} &nbsp;</b>
            {values?.reviewer1}
          </div>

          <div>
            <b>{t('Oponent 2')} &nbsp;</b>
            {values?.reviewer2}
          </div>

          <div>
            <b>{t('Oponent 3')} &nbsp;</b>
            {values?.reviewer3}
          </div>

          <div>
            <div>
              <b>{t('Abstrakt (slovensky)')} &nbsp;</b>
            </div>
            <RawHtml>{values?.abstract_sk}</RawHtml>

            <div>
              <b>{t('Abstrakt (anglicky)')} &nbsp;</b>
            </div>
            <RawHtml>{values?.abstract_en}</RawHtml>
          </div>

          <div>
            {renderFilePreview(
              t,
              values?.summary_file,
              t('Autoreferát dizertačnej práce'),
            )}
          </div>

          <div>
            {renderFilePreview(t, values?.fulltext_file, t('Text práce'))}
          </div>
        </div>
      </StyledModal>
    </div>
  );
};

PhdThesesDefendModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  values: PropTypes.object,
};

export default PhdThesesDefendModal;
